import {
  ArrayInput,
  Create,
  ImageInput,
  required,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
} from "react-admin";
import ApcMediaField from "../common/ApcMediaField";
import { MyCustomRichTextInput } from "../common/CustomRichTextInput";
// import { CustomRichTextInput } from "../common/CustomRichTextInput";

const CreateItem = (props: any) => {
  return (
    <Create {...props} title="Create news" redirect="/news">
      <SimpleForm>
        <TextInput
          label="title"
          source="title"
          validate={required()}
          fullWidth
          resettable
        />
        <TextInput
          label="short content"
          source="shortContent"
          validate={required()}
          fullWidth
          multiline
          resettable
        />
        {/* <CustomRichTextInput
          label="content"
          source="content"
          validate={required()}
          fullWidth
        /> */}
        <MyCustomRichTextInput/>

        <ImageInput
          label="Wallpaper"
          source="wallpaper"
          fullWidth
          accept="image/*"
          format={(src) =>
            typeof src == "string" ? { src, type: props } : src
          }
        >
          <ApcMediaField source="src" fullWidth />
        </ImageInput>
        <TextInput
          label="description"
          source="description"
          multiline
          fullWidth
        />
        <ImageInput
          label="Thumbnail"
          source="thumbnail"
          fullWidth
          accept="image/*"
          format={(src) =>
            typeof src == "string" ? { src, type: props } : src
          }
        >
          <ApcMediaField source="src" fullWidth />
        </ImageInput>
        <ArrayInput source="tags">
          <SimpleFormIterator>
            <TextInput source="" />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreateItem;
